module.exports = __webpack_public_path__ + "img/DNARepair-MELA_SpatialResearch.5fc7333c.png";